import { Route } from '../../../@types/routes';
import { EditableRouteListItem } from './editable-route-list-item';

type RoutesListProps = {
  routes: Route[];
  onRouteClick: (route: Route) => void;
  onToggleRouteSelect: (route: Route) => void;
  onEditRouteClick: (route: Route) => void;
  selectedRoutes?: string[];
};

export const RoutesList = ({
  routes,
  onRouteClick,
  selectedRoutes,
  onToggleRouteSelect,
  onEditRouteClick,
}: RoutesListProps) => {
  if (routes.length <= 0) {
    return <div>אין מסלולים</div>;
  }

  return (
    <>
      {routes.map((route) => {
        return (
          <EditableRouteListItem
            onClick={() => {
              onRouteClick(route);
            }}
            key={route.id}
            isSelected={selectedRoutes?.includes(route.id) || false}
            route={route}
            onToggleSelect={() => {
              onToggleRouteSelect(route);
            }}
            onEditClick={() => {
              onEditRouteClick(route);
            }}
          />
        );
      })}
    </>
  );
};
